// extracted by mini-css-extract-plugin
export default {"team":"Team_team__NTuVD","team_main":"Team_team_main__wnrVl","slide":"Team_slide__EizsJ","img":"Team_img__-F+VK"};